import { StyledAlert } from "App/global-style";
import React from "react";

type variants = { error?: string; warning?: string; success?: string };
type Props = { inputId: string } & variants;

export const FieldError = (props: Props): React.ReactElement | null => {
  const { inputId, error, warning, success } = props;
  const attentionId = `${inputId}-input-attention`;

  if (typeof error === "string") {
    return <StyledAlert type="error" title={error} id={attentionId} />;
  }

  if (typeof warning === "string") {
    return <StyledAlert type="warning" title={warning} id={attentionId} />;
  }

  if (typeof success === "string") {
    return <StyledAlert type="success" title={success} id={attentionId} />;
  }

  return null;
};
